// language=GraphQL
export const ALL_CURRENCIES_QUERY = `query Query {
  currencies: currencies {
    id
    name
    symbol
  }
}`

// language=GraphQL
export const SINGLE_CURRENCY_QUERY = `query Query($id: ID!) {
  currency: currency(id: $id) {
    id
    name
    symbol
  }
}`

// language=GraphQL
export const CREATE_CURRENCY_MUTATION = `
  mutation Mutation($input: CreateCurrencyInput) {
    currency: createCurrency(input: $input) {
      id
      name
      symbol
    }
  }`

// language=GraphQL
export const UPDATE_CURRENCY_MUTATION = `
  mutation Mutation($input: UpdateCurrencyInput) {
    currency: updateCurrency(input: $input) {
      id
      name
      symbol
    }
  }`

// language=GraphQL
export const DELETE_CURRENCY_MUTATION = `
  mutation Mutation($input: DeleteCurrencyInput) {
    deleteCurrency(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CURRENCY_MUTATION = `
  mutation Mutation($input: DeleteCurrencyInput) {
    forceDeleteCurrency(input: $input) {
      success
    }
  }`
